import React from 'react';

import Button from 'react-bootstrap/Button';
import {Col, Row, Image, InputGroup, Form, Container, Card} from "react-bootstrap";

function Features() {
    const InfoCol = (props: {title: any, children: any}) => {
        return (
            <Col sm={12} md={12} lg={4}>
                <Card style={{marginBottom: 40, minHeight: 450}}>
                    <Card.Body style={{textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                        <h4>{props.title}</h4>
                        <p>{props.children}</p>
                    </Card.Body>
                </Card>
            </Col>
        );
    }

    return (
        <Container style={{marginTop: 100, padding: 20}}>
            <Row className={'justify-content-center'}>
               <InfoCol title={"One-Line Context Input"}>
                Simply provide one line of text describing your context, and get precise symbol suggestions tailored to your needs.       
                </InfoCol>
        
                <InfoCol title={"Comprehensive Symbol Library"}>
                Access an extensive library of iOS symbols, including icons, assets, and more, to ensure you always have the perfect symbol at your fingertips.                
                </InfoCol>
                
                <InfoCol title={"Boost Productivity"}>
                Spend less time searching for symbols and more time focusing on building amazing apps.
                </InfoCol>
            </Row>
        </Container>
    );
}

export default Features;
